import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import {MatSort, MatPaginator, MatTableDataSource} from "@angular/material";
import {SubjectService} from "../../service/subject.service";
import {Subject} from "../../model/subject";
import {Validators, FormGroup, FormBuilder} from "@angular/forms";
import {SubjectType} from "../../model/subject-type";
import {ActivityType} from "../../model/activity-type";
import {HttpParams} from "@angular/common/http";
import {TranslateService} from "@ngx-translate/core";

let emptyType = new SubjectType();
emptyType.id = 0;
emptyType.name = 'Все';
let emptyActivityType = new ActivityType();
emptyActivityType.id = 0;
emptyActivityType.name = 'Все';
let emptyParent = new Subject();
emptyParent.id = 0;
emptyParent.bin = '0';
emptyParent.name = 'Все';

@Component({
  selector: 'app-subject-list',
  templateUrl: './subject-list.component.html',
  styleUrls: ['./subject-list.component.css']
})
export class SubjectListComponent implements OnInit {
  displayedColumns: string[] = ['id', 'name', 'bin', 'organizationSubject'];
  dataSource: MatTableDataSource<Subject>;
  pageSizeArray = [10, 25, 50, 100];
  isLoading = false;

  @ViewChild(MatPaginator)
  paginator: MatPaginator;
  @ViewChild(MatSort)
  sort: MatSort;

  filter: FormGroup;
  types: SubjectType[] = [emptyType];
  parents: Subject[] = [emptyParent];
  activityTypes: ActivityType[] = [emptyActivityType];

  constructor(
    private service: SubjectService,
    private router: Router,
    private formBuilder: FormBuilder,
    private translateService: TranslateService
  ) {
    this.dataSource = new MatTableDataSource([]);
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit() {
    this.buildFilter();
    this.loadData();

    this.f['parent'].disable();

    this.service.getAllTypes().subscribe(data => {
      this.setNamesTranslation(data, 'COMPANIES.TYPES');
      this.types = this.types.concat(data);
    });
    this.service.getActivityTypes().subscribe(data => {
      this.setNamesTranslation(data, 'COMPANIES.ACTIVITY_FORM')
      this.activityTypes = this.activityTypes.concat(data);
    });
    this.setNamesTranslation([emptyType, emptyParent, emptyActivityType], 'OTHER.ALL');
  }

  setNamesTranslation(data: any, key: string) {
    this.translateService.stream(key).subscribe(translations => {
      data.forEach((item, index) => {
        if(Array.isArray(translations)) {
          item.name = translations[index];
        } else {
          item.name = translations;
        }
      });
    });
  }

  loadData() {
    this.isLoading = true;
    let params = new HttpParams()
      .set('type', this.f['type'].value == null ? 0 : this.f['type'].value.id)
      .set('parent', this.f['parent'].value == null ? 0 : this.f['parent'].value.id)
      .set('activityType', this.f['activityType'].value == null ? 0 : this.f['activityType'].value.id)
      .set('name', this.f['name'].value)
      .set('bin', this.f['bin'].value)
      .set('pageIndex', this.paginator.pageIndex == null ? '0' : String(this.paginator.pageIndex))
      .set('pageSize', this.paginator.pageSize == null ? '10' : String(this.paginator.pageSize))
      .set('organizationSubject', this.f['organizationSubject'] == null ? 0 : this.f['organizationSubject'].value.id);

    this.loadCount(params);
    this.service.getAll({params: params}).subscribe(
      data => {
        this.isLoading = false;
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.sortingDataAccessor = (item, property) => {
          switch(property) {
            case 'type': return item.type == null ? null : item.type.name;
            case 'activityType': return item.activityType == null ? null : item.activityType.name;
            case 'parentSubject': return item.parent == null ? null : item.parent.name;
            case 'organizationSubject': return item.catalogueOrganization == null ? null : item.catalogueOrganization.name;
            default: return item[property];
          }
        };
        this.dataSource.sort = this.sort;
      }
    );
  }

  loadCount(params: HttpParams) {
    this.service.getCount({params: params}).subscribe(count => {
      this.paginator.length = count;
    });
  }

  edit() {
      this.router.navigate(['subject']);
  }
  //---------------------------------------------FILTER-----------------------------------------------------------------

  get f() {
    return this.filter.controls;
  }

  doFilter() {
    this.paginator.firstPage();
    this.loadData();
  }

  resetFilter () {
    this.f['parent'].disable();
    this.buildFilter();
    this.paginator.firstPage();
    this.loadData();
  }

  private buildFilter() {
    this.filter = this.formBuilder.group({
      bin: '',
      name: '',
      type: this.types[0],
      parent: this.parents[0],
      activityType: this.activityTypes[0]
    });
  }

  loadParentSubjects(type: SubjectType) {
    this.f['parent'].disable();
    this.f['parent'].setValue(this.parents[0]);
    this.f['activityType'].setValue(this.activityTypes[0]);
    if (type.name.indexOf('Другие ЮЛ') != -1) {
      this.f['activityType'].enable();
      return;
    }
    if (type.parent != null) {
      this.service.getByType(type.parent).subscribe(data => {
        if (data.length > 0) {
          this.parents = this.parents.concat(data);
          this.f['parent'].enable();
          this.f['parent'].setValue(this.parents[0]);
        }
      });
    }
  }
}
